module.exports = __webpack_public_path__ + "2506bd407eddb78bed437e9f386e7b43.png";